import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { FONT, BG_WHITE, BG_TINT, BORDER, DIVIDER, RADIUS_CARD, CARD_SHADOW, PURPLE_MAIN, tableHeaderSx } from "./bentoTokens";

// Pure styling wrapper around MUI DataGrid — wraps it in bento card chrome and restyles
// headers/rows/pagination, but forwards every prop/handler unchanged (sorting, filtering,
// pagination, selection, custom toolbars, etc. all keep working exactly as before).
const StyledDataGrid = ({ containerSx, sx, autoHeight = true, ...dataGridProps }) => (
  <Box
    sx={{
      background: BG_WHITE,
      border: `1px solid ${BORDER}`,
      borderRadius: RADIUS_CARD,
      boxShadow: CARD_SHADOW,
      overflow: "hidden",
      ...containerSx,
    }}
  >
    <DataGrid
      autoHeight={autoHeight}
      {...dataGridProps}
      sx={{
        border: "none",
        fontFamily: FONT,
        "& .MuiDataGrid-columnHeaders": {
          ...tableHeaderSx,
          background: BG_TINT,
          borderBottom: `1px solid ${BORDER}`,
        },
        "& .MuiDataGrid-row:hover": { background: BG_TINT },
        "& .MuiDataGrid-cell": { borderBottom: `1px solid ${DIVIDER}` },
        "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${BORDER}` },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${PURPLE_MAIN} !important`,
        },
        ...sx,
      }}
    />
  </Box>
);

export default StyledDataGrid;
